import { memo, useContext } from "react";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { FormattedMessage } from "react-intl";
import Paragraphs from "app/pages/.shared/Paragraphs";
import "./MerchandisingMediasIntro.scss";
import Button from "app/pages/.shared/form/Button";
import { scrollToElement } from "app/utils/scroller";
import ArrowDownward from "app/pages/.shared/static/icons/ArrowDownward";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { isEmpty } from "lodash";

const MerchandisingMediasIntro = ({ mediaIntroduction = {}, fromPrice, scrollTargetRef }) => {
	const { title = "", description } = mediaIntroduction;
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;
	const handleClick = () => {
		scrollToElement({
			element: scrollTargetRef?.current,
			disableSmoothScroll: false,
		});
	};
	return (
		title &&
		!isEmpty(description) && (
			<div className="merchandising-medias-intro">
				<div className="merchandising-medias-intro__title">
					<Typography
						variant={TYPOGRAPHY_VARIANTS.XL7}
						variantMD={TYPOGRAPHY_VARIANTS.XL9}
						isBold
						className="merchandising-medias-intro__title-label"
						data-testid="merchandising-medias-intro-title-label"
					>
						{title}
					</Typography>
					{fromPrice > 0 && (
						<AmountContainer
							prefix={<FormattedMessage id="general.from.label" />}
							suffix={
								<FormattedMessage id="general.amount.per.person.suffix.label.short" />
							}
							amount={fromPrice}
						/>
					)}
				</div>
				{isMobile && (
					<div className="merchandising-medias-intro__button">
						<Button variant="secondary" onClick={handleClick}>
							<FormattedMessage id="listing.filter.menu.cta.label" />
							<ArrowDownward />
						</Button>
					</div>
				)}
				<div className="merchandising-medias-intro__description">
					<Typography
						variant={TYPOGRAPHY_VARIANTS.LARGE}
						variantMD={TYPOGRAPHY_VARIANTS.XL}
						isBold
						className="merchandising-medias-intro__description-content"
						data-testid="merchandising-medias-intro-description-content"
					>
						<Paragraphs paragraphs={description} enableHTMLFormatting />
					</Typography>
					<div />
				</div>

				{!isMobile && (
					<div className="merchandising-medias-intro__button">
						<Button variant="secondary" onClick={handleClick}>
							<FormattedMessage id="listing.filter.menu.cta.label" />
							<ArrowDownward />
						</Button>
					</div>
				)}
			</div>
		)
	);
};

MerchandisingMediasIntro.propTypes = {
	mediaIntroduction: PropTypes.object,
	fromPrice: PropTypes.number,
	scrollTargetRef: PropTypes.object,
};

export default memo(MerchandisingMediasIntro);
